import getConfig from "next/config"
import { SpinnerProps } from "./spinner-props"

function SpinnerImage({
    height = 64,
    width = 64
}: SpinnerProps) {
    const { NEXT_PUBLIC_STATIC_DOMAIN } = getConfig().publicRuntimeConfig

    return (
        <img
            height={height}
            width={width}
            src={`https://${NEXT_PUBLIC_STATIC_DOMAIN}/images/loading.svg`}
            alt="loading"
        />        
    )
}

export default SpinnerImage
